import { useEffect, useMemo, useState } from "react";
import useProjectDomains from "../../../../api/utilities/useProjectDomains.js";
import { ProjectApi } from "../../../../api/authority/generated/index";
import useAuthorityConfiguration from "../../../../api/utilities/useAuthorityConfiguration.js";
import { useTranslation } from "react-i18next";
import Creatable from "react-select/creatable";
import Button from "../../../../components/Button.jsx";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import Spinner from "../../../../components/Spinner.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";

export default function HostNameApiIdApiKeyList({
                                                     project,
                                                     projectIntegration,
                                                     value,
                                                     onChange
                                                 }) {
    const { t } = useTranslation();
    const authorityConfiguration = useAuthorityConfiguration();
    const projectDomains = useProjectDomains(project);
    const [projectDomainNameWithApiIdApiKeyList, setProjectDomainNameWithApiIdApiKeyList] = useState(null);

    useEffect(() => {
        if (projectIntegration === null) {
            setProjectDomainNameWithApiIdApiKeyList([]);
            return;
        }

        new ProjectApi(authorityConfiguration)
            .hostNameApiIdApiKey({
                integrationId: projectIntegration.id
            })
            .then(setProjectDomainNameWithApiIdApiKeyList)
            .catch(() => setProjectDomainNameWithApiIdApiKeyList([]));
    }, [project.id, projectIntegration?.id]);

    const hostNameOptions = useMemo(() => {
        if (projectDomains === null) return [];
        return projectDomains.map((projectDomain) => ({
            value: projectDomain.projectDomain.hostName,
            label: projectDomain.projectDomain.hostName
        }));
    }, [projectDomains]);

    useEffect(() => {
        if (projectDomainNameWithApiIdApiKeyList !== null && value.length === 0) {
            const initialValue = projectDomainNameWithApiIdApiKeyList.length > 0
                ? projectDomainNameWithApiIdApiKeyList
                : [{ hostName: '', apiId: '', apiKey: '' }];
            onChange(initialValue);
        }
    }, [projectDomainNameWithApiIdApiKeyList]);

    const handleDelete = (index) => {
        const newValue = value.filter((_, checkedIdx) => index !== checkedIdx);
        if (newValue.length === 0) {
            onChange([{ hostName: '', apiId: '', apiKey: '' }]);
        } else {
            onChange(newValue);
        }
    };

    const handleAdd = () => {
        onChange([...value, { hostName: '', apiId: '', apiKey: '' }]);
    };

    return (
        <LoadingComponent
            className={'border-1 p-3 border-slate-500 rounded'}
            loading={projectDomainNameWithApiIdApiKeyList === null}
        >
            {projectDomains === null && <Spinner />}
            {projectDomains && (
                <div>
                    {(value ?? []).map((row, index) => (
                        [
                            <div className={'flex gap-2 pt-2'} key={`xml-link-row-1-${index}`}>
                                <Creatable
                                    value={{ label: row.hostName, value: row.hostName }}
                                    className={'w-6/12'}
                                    onChange={(e) => {
                                        const newValue = [...value];
                                        newValue[index] = { ...row, hostName: e.value };
                                        onChange(newValue);
                                    }}
                                    options={hostNameOptions}
                                />
                                <input
                                    placeholder={'ShopID'}
                                    value={row.apiId}
                                    className={'w-6/12 form-input'}
                                    type={'text'}
                                    onChange={(e) => {
                                        const newValue = [...value];
                                        newValue[index] = { ...row, apiId: e.target.value };
                                        onChange(newValue);
                                    }}
                                />
                            </div>,
                            <div className={'flex gap-2 pt-2 border-b-1 pb-2 border-slate-500'} key={`xml-link-row-2-${index}`}>
                                <input
                                    placeholder={'API key'}
                                    value={row.apiKey}
                                    className={'w-11/12 form-input'}
                                    type={'text'}
                                    onChange={(e) => {
                                        const newValue = [...value];
                                        newValue[index] = { ...row, apiKey: e.target.value };
                                        onChange(newValue);
                                    }}
                                />
                                <Button
                                    className={'button button-danger-outline w-1/12'}
                                    onClick={() => handleDelete(index)}
                                >
                                    <FontAwesomeIcon icon={faTrashCan} />
                                </Button>
                            </div>
                        ]
                    ))}
                    <div className={'pt-2'}>
                        <Button
                            className={'button button-success-outline'}
                            onClick={handleAdd}
                        >
                            {t('add-settings-for-next-domain')}
                        </Button>
                    </div>
                </div>
            )}
        </LoadingComponent>
    );
}